import { createIcon } from './createIcon'

export const ChevronIcon = createIcon({
  displayName: 'ChevronIcon',
  viewBox: '0 0 12 7',
  path: [
    <path
      d="M11 1L6 6L1 1"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
})
